import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import {
  User,
  EnvelopeSimple,
  Phone,
  MapPin,
  GitBranch,
  Suitcase,
} from 'phosphor-react';

import PageShell from './home-components/PageShell';
import FormField from './home-components/FormField';
import CustomAlert from './CustomAlert';
import CustomLoading from './CustomLoading';
import MessageTypes from 'enums/message-types';
import kediOturan from 'assets/img/home/kedi-oturan.png';

import { connect } from 'react-redux';
import { SEND_CONTACT_FORM, sendContactForm } from 'redux/actions/pages';
import { removeMessage } from 'redux/actions/message';

function ContactPage({
  backendMessage,
  sendContactForm,
  removeMessage,
  localizations,
}) {
  const [rod, setRod] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      backendMessage &&
      backendMessage.messageContent !== undefined &&
      backendMessage.messageContent !== null &&
      backendMessage.messageContent !== ''
    ) {
      Swal.fire({
        icon: backendMessage.messageType || 'error',
        title:
          backendMessage.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS
            : localizations?.MESSAGE_ERROR,
        text: backendMessage.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_CONFIRM_BTN,
        confirmButtonColor: '#174b87',
      }).then((_) => {
        removeMessage(SEND_CONTACT_FORM);
        if (backendMessage.messageType === MessageTypes.success) {
          setRod('');
          setName('');
          setEmail('');
          setNumber('');
          setMessage('');
        }
      });
    }
    // eslint-disable-next-line
  }, [backendMessage]);

  const offices = [
    {
      icon: MapPin,
      title: localizations?.CONTACT_HEAD_OFFICE_TITLE ?? 'Merkez Ofis',
      text:
        localizations?.CONTACT_HEAD_OFFICE_ADDRESS ??
        'Edict Digital Bilgi Teknolojileri A.Ş.\nKavacık Mah. Gülşen Sk. No: 12/3\nBeykoz / İSTANBUL',
    },
    {
      icon: GitBranch,
      title: localizations?.CONTACT_BRANCH_OFFICE_TITLE ?? 'Şube (AR-GE)',
      text:
        localizations?.CONTACT_BRANCH_OFFICE_ADDRESS ??
        'Malatya Teknokent\nİnönü Üniversitesi Karşısı\nBattalgazi / MALATYA',
    },
    {
      icon: Suitcase,
      title: localizations?.CONTACT_COMPANY_TITLE ?? 'Şirket Bilgileri',
      text:
        localizations?.CONTACT_COMPANY_DETAILS ??
        'Edict Digital Bilgi Teknolojileri A.Ş.\nBeykoz VD · 324 096 4833',
    },
  ];

  return (
    <>
      <CustomAlert />
      <CustomLoading />
      <PageShell
        path="/contact"
        kicker={localizations?.CONTACT_HEADER ?? 'İletişim'}
        title="Size nasıl yardımcı olabiliriz?"
        text={
          localizations?.CONTACT_DESC ??
          'Ürünlerimizle ilgili her konuda bizimle iletişime geçebilirsiniz. En kısa sürede sizlerle temas kuracağız.'
        }
      >
        <form
          id="contact-form"
          method="post"
          className="op-form-card contact-form"
        >
          <input
            className="op-hp"
            aria-label="Rod"
            autoComplete="off"
            tabIndex={-1}
            type="text"
            value={rod}
            onChange={(e) => setRod(e.target.value)}
          />
          <FormField
            id="contact-name"
            label={localizations?.FORM_NAME ?? 'İsim'}
            icon={User}
            required
          >
            <input
              id="contact-name"
              autoComplete="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormField>
          <div className="op-form-row">
            <FormField
              id="contact-email"
              label={localizations?.FORM_EMAIL ?? 'Eposta'}
              icon={EnvelopeSimple}
              required
            >
              <input
                id="contact-email"
                autoComplete="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormField>
            <FormField
              id="contact-phone"
              label={localizations?.FORM_PHONE ?? 'Telefon No'}
              icon={Phone}
            >
              <input
                id="contact-phone"
                autoComplete="tel"
                type="tel"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </FormField>
          </div>
          <FormField
            id="message"
            label={localizations?.FORM_MESSAGE ?? 'Mesaj'}
            required
          >
            <textarea
              id="message"
              name="message"
              rows="6"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormField>
          <button
            className="op-btn op-btn--primary op-btn--lg op-form-card__submit"
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              if (rod === '') {
                sendContactForm({
                  name,
                  email,
                  phone: number,
                  message,
                });
              }
            }}
          >
            {localizations?.FORM_SEND_BTN ?? 'Gönder'}
          </button>
        </form>

        <aside className="op-page__aside">
          {offices.map((office) => {
            const Icon = office.icon;
            return (
              <div className="op-info" key={office.title}>
                <span className="op-info__icon">
                  <Icon size={24} weight="duotone" />
                </span>
                <div>
                  <h2>{office.title}</h2>
                  <p>{office.text}</p>
                </div>
              </div>
            );
          })}
          <div className="op-teaser">
            <img src={kediOturan} alt="" aria-hidden="true" />
            <h2>Okulunuz için teklif mi almak istiyorsunuz?</h2>
            <p>Birkaç bilgiyle formu doldurun, ekibimiz size özel teklifle dönsün.</p>
            <a className="op-btn op-btn--accent" href="/buy-now">
              Teklif İste →
            </a>
          </div>
        </aside>
      </PageShell>
    </>
  );
}

const mapStateToProps = (state) => ({
  backendMessage: state.message[SEND_CONTACT_FORM],
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {
  sendContactForm,
  removeMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPage);
